<template>
  <div>
    <v-row class="d-flex justify-sm-end">
      <v-col cols="12" sm="6" lg="3">
        <v-btn color="primary" outlined :to="`/manage/forms/${operation.object_type}/${operation.form_name}/${operation.id}`">
          {{ $t("button.see.originalForm") }}
        </v-btn>
      </v-col>
      <v-col v-if="operation.object_id" cols="12" sm="6" lg="3">
        <v-btn color="purple" outlined :to="`/manage/edit/industrialProperties/edit/${operation.object_id}`">
          {{ $t("button.see.editObject") }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="6" sm="3" md="2"><FinishFormSwitch :item="operation" /></v-col>
      <v-col cols="6" sm="3" md="3" lg="2"><ProcessingCommentDialog :moderated-operation="operation" /></v-col>
    </v-row>
    <v-card v-if="operation.data" class="pa-6 mb-4">
      <IndustrialPropertyFields :industrial-property="item" readonly />
      <v-divider class="mt-6 mb-5" />
      <IndustrialPropertyFiles :id="operation.id" readonly />
    </v-card>
    <ProcessFormActions :item="operation" @item-processed="handleProcessed" />
  </div>
</template>
<script>
import axios from "axios";
import FinishFormSwitch from "@/components/reusables/FinishFormSwitch";
import IndustrialPropertyFields from "@/components/industrialProperty/IndustrialPropertyFields.vue";
import IndustrialPropertyFiles from "@/components/industrialProperty/IndustrialPropertyFiles.vue";
import ProcessFormActions from "@/components/action_buttons/ProcessFormActions";
import ProcessingCommentDialog from "@/components/reusables/ProcessingCommentDialog";
import { createDefaultIndustrialProperty, normalizeIndustrialProperty } from "@/utils/industrialProperty";

export default {
  name: "ProcessIndustrialProperty",
  components: {
    FinishFormSwitch, IndustrialPropertyFields, IndustrialPropertyFiles, ProcessFormActions, ProcessingCommentDialog
  },
  data: () => ({ operation: {}, item: createDefaultIndustrialProperty() }),
  created() {
    axios.get(`${this.$store.state.endpoint}/moderatedOperations/review/industrial_property/${this.$route.params.id}`)
      .then(response => {
        this.operation = response.data;
        this.item = normalizeIndustrialProperty(response.data.data.user.industrial_property);
      }).catch(error => console.error(error));
  },
  methods: {
    handleProcessed(item) { this.operation.state = item.state; this.operation.object_id = item.object_id; }
  }
};
</script>
